import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Button from '../../components/ui/Button';
import Loader from '../../components/ui/Loader';
import SimpleLoader from '../../components/ui/SimpleLoader';
import { useApiReload } from '../../context/apiRelaod';
import { useAuth } from '../../context/authContext';
import {
	DownloadNote,
	FormCreate,
	FormId,
	FormIdNotes,
	FormModelOption,
	SoapList,
	viewModelPdf,
} from '../../services/apiService';
import { dateFormat } from '../../utils/priceFormat.util';
import Label from '../../components/form/Label';
import { useParams } from 'react-router-dom';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../components/ui/Modal';
import { useResourceUsage } from '../../context/ResourceUsageContext';

interface FormIdD {
	formId: string;
	formName: string;
	formType: string;
	createdAt: string;
	updatedAt: string;
	noteFormId?: string;
	isCreated?: boolean;
	formUrl?: string;
}
interface NoteIdD {
	id: string;
	caseId: string;
	noteType: string;
	createdAt: string;
	isCreated?: boolean;
}
interface FormIdView {
	noteId: string;
	caseid: string;
	formId: string;
	formUrl: string;
}

const PatientForm = () => {
	const navigate = useNavigate();
	const { state } = useLocation();
	const { caseData, noteid } = state || {};
	const { patientID } = useApiReload();
	const { onLogout } = useAuth();
	const [activeTab, setActiveTab] = useState(1);
	const [showCreateFormModal, setShowCreateFormModal] = useState(false);
	const [selectedFollowUpId, setSelectedFollowUpId] = useState(noteid || '');
	const [selectedNoteId, setSelectedNoteId] = useState('');
	const [formLoading, setFormLoading] = useState(false);
	const [selectedForm, setSelectedForm] = useState<string>();
	const [activeButton, setActiveButton] = useState<string>();
	const [activeButtonView, setActiveButtonView] = useState<string>();
	const [createViewOptions, setCreateViewOptions] = useState<FormIdD[]>([]);
	const [formData1, setFromData] = useState<any[]>([]);
	const [noteFormData, setnoteFormData] = useState<any[]>([]);
	const [ButtonLoading, setButtonLoading] = useState<{ id?: string; loading: boolean }[]>([]);
	const { call: formId, loading: formIdLoading } = FormId();
	const { Soapcall: noteId, loading: noteIdLoading } = SoapList();
	const { call: formIdView, loading: formViewLoading } = FormIdNotes();
	const { call: formCreate, loading: formCreateLoading } = FormCreate();
	const { call: formCreateView, loading: formCreateViewLoading } = FormModelOption();
	const { call: formViewPdf, loading: formviewPdfLoading } = viewModelPdf();
	const [formIdData, setFormIdData] = useState<FormIdD[]>([]);
	const [noteIdData, setNoteIdData] = useState<NoteIdD[]>([]);
	const [formIdViewData, setFormIdViewData] = useState<any[]>([]);
	const { DownloadCall } = DownloadNote();
	const cacheRef = useRef<FormIdD[]>([]);
	const [loadingIndex, setLoadingIndex] = useState<number | null>(null);
	const { routeNoteId } = useParams();
	const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
	const [modalData, setModalData] = useState<{
		s3_bucket?: string;
		s3_key?: string;
		formId?: string;
	} | null>(null);
	const { setUsage } = useResourceUsage();
	if (!patientID || !caseData) {
		return (
			<div className='flex h-screen items-center justify-center'>
				{/* <Loader /> */}
				<SimpleLoader />
			</div>
		);
	}

	useEffect(() => {
		if (!caseData?.id) return;

		noteId(caseData.id).subscribe({
			next(res: any) {
				setNoteIdData(res?.data);
				if (routeNoteId != undefined) {
					handleNoteClick(String(routeNoteId));
					formCreateView({ noteId: routeNoteId }).subscribe({
						next(res: any) {
							setnoteFormData(res?.data);
						},
					});
				} else {
					if (res?.data && res?.data.length > 0) {
						handleNoteClick(String(res?.data[0].id));
						formCreateView({ noteId: res?.data[0].id }).subscribe({
							next(res: any) {
								setnoteFormData(res?.data);
							},
						});
					}
				}
			},
		});
	}, []);

	const onCreateForm = (formid: string, name: string) => {
		setActiveButton(formid);
		if (!ButtonLoading.some((button) => button.id === formid)) {
			setButtonLoading([...ButtonLoading, { id: formid, loading: true }]);
		}

		const data = {
			noteId: selectedNoteId,
			formId: formid,
			formUrl: 'https://example.com/form',
		};
		formCreate(data).subscribe({
			next(res: any) {
				toast.success(` ${name} created successfully.`);
				updateCreateViewOptions();
				setButtonLoading((prev) =>
					prev.map((btn) =>
						btn.id === formid ? { ...btn, loading: false } : btn
					)
				);
				handleNoteClick(selectedNoteId);
				setUsage((prev) => ({
					...prev,
					formsCount: res?.data?.formsCount || prev.formsCount,
				}));
			},

			error(e: any) {
				const toastId = 111;
				if (!toast.isActive(toastId)) {
					toast.error(e?.data?.msg || e.message, { toastId });
				}
				console.log(e?.data?.msg || e.message);
				console.error('An error occurred:', e);
				setButtonLoading((prev) =>
					prev.map((btn) =>
						btn.id === formid ? { ...btn, loading: false } : btn
					)
				);
			},
		});
	};

	const loadFormData = (noteId: string, showLoadingState = true) => {
		if (showLoadingState) {
			setFormLoading(true);
		}

		const data = { noteId };

		const subscription = formCreateView(data).subscribe({
			next(res: any) {
				if (showLoadingState) {
					setFormLoading(false);
				}

				if (res?.data) {
					const isDataDifferent =
						JSON.stringify(cacheRef.current) !== JSON.stringify(res.data);

					if (isDataDifferent) {
						cacheRef.current = res.data;

						setCreateViewOptions((prevOptions) => {
							if (
								prevOptions.length === res.data.length &&
								JSON.stringify(prevOptions) === JSON.stringify(res.data)
							) {
							}
							// console.log(res.data);
							setButtonLoading(
								ButtonLoading.filter(
									(button) =>
										!res.data.some(
											(form: any) =>
												form.formId === button.id && form.formUrl,
										),
								),
							);

							return [...res.data];
						});
					}
				}
			},
			error(err) {
				if (showLoadingState) {
					setFormLoading(false);
				}
			},
		});

		return subscription;
	};

	// For updating with existing ID
	const updateCreateViewOptions = () => {
		if (selectedFollowUpId) {
			loadFormData(selectedFollowUpId, false);
		}
	};

	const handleNoteClick = (noteId: string) => {
		setSelectedNoteId(noteId);
		formCreateView({ noteId }).subscribe({
			next(res: any) {
				setnoteFormData(res?.data);
			},
		});
	};

	const handleViewPdf = (
		formUrl: any,
		formId: string,
		index: number,
		formCreate: boolean,
		needToUseOld: boolean,
	) => {
		formUrl = JSON.parse(formUrl);
		formUrl.noteId = selectedNoteId;
		formUrl.formId = formId;
		formUrl.forceCreate = formCreate;
		setActiveButtonView(formId);
		setLoadingIndex(index);
		setModalData(formUrl);
		formViewPdf(JSON.stringify(formUrl)).subscribe({
			next: (res: any) => {
				if (res?.data?.updated && !needToUseOld) {
					setUpdateModalOpen(true);
				} else {
					const byteArray = res?.data?.pdf?.data; // assuming 'data' contains the array of bytes
					const blob = new Blob([new Uint8Array(byteArray)], { type: 'application/pdf' });
					const url = URL.createObjectURL(blob);
					setUpdateModalOpen(false);
					window.open(url, '_blank');
					setLoadingIndex(null);
					setTimeout(() => {
						URL.revokeObjectURL(url);
					}, 5000);
				}
			},
			error: (error: any) => {
				setLoadingIndex(null);
				if (error?.status === 409) {
					onLogout(error?.status);
				}
				console.error('Error in Opening the PDF:', error);
			},
		});
	};

	return (
		<>
			<div className='mb-24 px-6 pt-3'>
				<div className='mb-6 flex items-center justify-between'>
					<h3 className='mb-0 mt-4 text-2xl font-semibold'>Patient Information:</h3>
					<Button
						variant='outline'
						color='gray'
						colorIntensity='500'
						className='flex items-center gap-2 text-sm'
						onClick={() => navigate(-1)}>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							className='h-4 w-4'
							fill='none'
							viewBox='0 0 24 24'
							stroke='currentColor'>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth={2}
								d='M10 19l-7-7m0 0l7-7m-7 7h18'
							/>
						</svg>
						Back
					</Button>
				</div>
				{patientID && (
					<div className='mb-6 rounded-lg bg-white p-6 shadow-md dark:bg-slate-800'>
						<div className='grid grid-cols-1 gap-6 md:grid-cols-3'>
							<div className='flex flex-col'>
								<span className='text-sm text-gray-500 dark:text-gray-400'>
									Patient Name
								</span>
								<span className='text-lg font-medium text-gray-900 dark:text-white'>
									{patientID.firstName} {patientID.lastName}
								</span>
							</div>
							<div className='flex flex-col'>
								<span className='text-sm text-gray-500 dark:text-gray-400'>
									Email
								</span>
								<span className='text-lg font-medium text-gray-900 dark:text-white'>
									{patientID.email}
								</span>
							</div>
							<div className='flex flex-col'>
								<span className='text-sm text-gray-500 dark:text-gray-400'>
									Mobile Number
								</span>
								<span className='text-lg font-medium text-gray-900 dark:text-white'>
									{patientID.moblieNo}
								</span>
							</div>
						</div>
					</div>
				)}
				<div className='my-2 py-3'>
					<div className='items-centsetSelectedFollowUpId(e.target.value);er flex flex-wrap gap-2'>
						<h3 className='text-2xl font-semibold'>Cases Id:</h3>
						<div className='flex flex-wrap items-end gap-2'>
							<p className='mb-0 text-xl'> {caseData.caseName}</p>
							<span className='text-md text-gray-500'>
								({dateFormat(caseData?.createdAt)})
							</span>
						</div>
					</div>
				</div>
				<div className='mb-6 rounded-lg bg-white p-6 shadow-md dark:bg-slate-800'>
					{noteIdLoading ? (
						<SimpleLoader />
					) : (
						noteIdData && (
							<div className='col-span-12'>
								<Label htmlFor='country'>Select Assessment or SOAP</Label>
								<select
									id='noteId'
									name='noteId'
									value={selectedNoteId}
									onChange={(e: any) => handleNoteClick(e.target.value)}
									className='rounded-md border border-gray-300 p-2'>
									{noteIdData.map((i) =>
										i ? (
											<option key={i.id} value={i.id}>
												{`${i.noteType}: ${i.id}`}
											</option>
										) : null,
									)}
								</select>
							</div>
						)
					)}
					{formCreateViewLoading ? (
						<SimpleLoader />
					) : (
						noteFormData &&
						noteFormData?.map((followUp: any, idx: any) => (
							<div
								key={followUp.noteId}
								className='border-grey-500 me-2 border-b-2 py-4'>
								<div className='flex flex-wrap items-center justify-between'>
									<div className='flex-col gap-3 py-2'>
										<h6 className='mb-2 text-lg font-semibold'>
											{followUp.formName}
											{/* : {followUp.noteId} */}
										</h6>
									</div>
									{followUp?.isCreated ? (
										<Button
											variant='solid'
											colorIntensity='500'
											className='primary-bg font-medium text-white'
											isLoading={loadingIndex === idx}
											onClick={() => {
												handleViewPdf(
													followUp.formUrl,
													followUp.formId,
													idx,
													false,
													false,
												);
											}}>
											View
										</Button>
									) : (
										<Button
											variant='solid'
											colorIntensity='500'
											className='primary-bg font-medium text-white'
											isLoading={ButtonLoading.some(
												(button) =>
													button.id === followUp.formId && button.loading,
											)}
											onClick={() => {
												onCreateForm(followUp.formId, followUp.formName);
											}}>
											Create
										</Button>
									)}
								</div>
							</div>
						))
					)}
				</div>
			</div>
			<Modal
				isOpen={isUpdateModalOpen}
				setIsOpen={setUpdateModalOpen}
				isCentered
				size='sm'
				closeOnOverlayClick={false}
				data={modalData}>
				<ModalHeader setIsOpen={setUpdateModalOpen}>Update Form</ModalHeader>
				<ModalBody className='pt-3'>
					<p className='mb-0 text-lg'>Do you want to regenerate form?</p>
				</ModalBody>
				<ModalFooter className='justify-end pt-3'>
					<Button
						variant='solid'
						color='gray'
						colorIntensity='500'
						className='cursor-pointer text-white'
						isLoading={formviewPdfLoading}
						onClick={() =>
							handleViewPdf(
								JSON.stringify({
									s3_bucket: modalData?.s3_bucket,
									s3_key: modalData?.s3_key,
								}),
								modalData?.formId ?? '',
								1,
								false,
								true,
							)
						}>
						No
					</Button>
					<Button
						variant='solid'
						colorIntensity='600'
						className='primary-bg cursor-pointer text-white'
						isLoading={formviewPdfLoading}
						onClick={() =>
							handleViewPdf(
								JSON.stringify({
									s3_bucket: modalData?.s3_bucket,
									s3_key: modalData?.s3_key,
								}),
								modalData?.formId ?? '',
								1,
								true,
								false,
							)
						}>
						Yes
					</Button>
				</ModalFooter>
			</Modal>
		</>
	);
};

export default PatientForm;
